export default "__VITE_ASSET__08dc79b1__"